var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_ionic-ios-checkmark-circle",
    x: 0,
    y: 0,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_ionic-ios-checkmark-circle)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle-2",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M15.875,3.375a12.5,12.5,0,1,0,12.5,12.5A12.5,12.5,0,0,0,15.875,3.375Zm6.4,9.044L14.24,20.49h-.006a1.085,1.085,0,0,1-.7.331,1.052,1.052,0,0,1-.7-.343L9.469,17.113a.239.239,0,0,1,0-.343l1.07-1.07a.232.232,0,0,1,.337,0l2.668,2.668,7.332-7.386a.237.237,0,0,1,.168-.072h0a.218.218,0,0,1,.168.072l1.052,1.088A.237.237,0,0,1,22.275,12.419Z",
    transform: "translate(5.63 0.63)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessicon);
export default __webpack_public_path__ + "static/media/success icon.7493656e1e87c9d00a8e218322b69bfe.svg";
export { ForwardRef as ReactComponent };